import { useState } from 'react'
import { BiMenu } from "react-icons/bi";
import logo from '../../pic/km-logo-png-transparent.png'

export default function Nav(){
    const [menuIs , setMenuIs] = useState(false)
    return(
        <div>
            <div className="w-full ms-auto me-auto absolute top-0 lg:flex  md:hidden hidden px-20 z-20 bg-gradient-to-r ">
                <div className='container mx-auto flex flex-row justify-between'>
                        {/* Icon */}
                    <div>
                        <img src={logo} alt="" className='w-[50px] h-[50px] lg:mt-4 md:mt-0 mt-0'/>
                    </div>
                    {/* Li Nav */}
                    <div className='row lg:mt-8 md:mt-0 mt-0 text-white'>
                        <a href="#about" className=' mx-7 font-semibold font-sans hover:text-[#999999]'>About me</a>
                        <a href="#skills" className=' mx-7 font-semibold font-sans hover:text-[#999999]'>Skills</a>
                        <a href="#portfolio" className=' mx-7 font-semibold font-sans hover:text-[#999999]'>Portfolio</a>
                        <a href="https://chatwith.io/s/kerlos-magdy" className=' mx-7 font-semibold font-sans  bg-white p-2 px-6
                        rounded-tl-2xl rounded-bl-2xl rounded-tr-2xl text-black rounded-br-2xl hover:text-[#999999] hover:bg-white'>CONTACT ME</a>
                    </div>
                </div>
            </div>
            {/* Nav For Mobile And tablet */}
            <div className='lg:hidden md:flex flex justify-between  z-50 bg-white  bg-opacity-70 py-2 px-8 absolute top-0 w-screen border-b-2'>
                    <div className='z-30'>
                        <img src={logo} alt="" className='w-[50px] h-[50px]'/>
                    </div>
                    {/* Li Nav */}
                    <button className='text-5xl z-50' onClick={()=> { 
                        setMenuIs(!menuIs)
                        }} >
                        <BiMenu />
                    </button>
                    
            </div>
            { menuIs && 
            <div className=' absolute top-[calc(65px)] left-0 z-30 bg-white bg-opacity-80 w-screen h-fit'>
                        <div className='flex flex-col text-black pt-3'>
                            <a href="#about" className=' mx-7 font-semibold font-sans hover:text-[#999999] py-3 border-b-2'>About me</a>
                            <a href="#skills" className=' mx-7 font-semibold font-sans hover:text-[#999999] py-3 border-b-2'>Skills</a>
                            <a href="#portfolio" className=' mx-7 font-semibold font-sans hover:text-[#999999] py-3 border-b-2'>Portfolio</a>
                            <a href="https://chatwith.io/s/kerlos-magdy" className=' mx-7 font-semibold font-sans hover:text-[#999999] py-3 mb-2'>CONTACT ME</a>
                        </div>
            </div>}
        </div>
    )
}